import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsConditions = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="terms-conditions-page">
      <Header />

      <div className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-16">
          <Link to="/" className="inline-flex items-center text-[#002FA7] hover:text-[#001D66] mb-6 transition-colors text-sm font-medium">
            <ArrowLeft className="w-4 h-4 mr-1" /> Home
          </Link>

          <h1 className="text-4xl font-black text-[#09090B] mb-6" style={{fontFamily:'Outfit,sans-serif'}}>Terms & Conditions</h1>

          <div className="prose max-w-none space-y-6 text-zinc-600">
            <p className="text-base leading-relaxed">
              By accessing the <strong className="text-[#09090B]">Trademark My Logo Name</strong> website (referred to as the "Site"), you acknowledge and accept the terms and conditions outlined herein, forming an agreement between you and info@trademarkmylogoname.com (referred to as "we," "us," or "our"). This agreement also incorporates our Privacy Policy as if fully stated here. If you do not agree with these terms, please refrain from using the Site.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 my-6">
              <p className="text-sm text-zinc-700">
                <strong>IMPORTANT:</strong> THIS AGREEMENT INCLUDES A MANDATORY ARBITRATION CLAUSE GOVERNED BY THE FEDERAL ARBITRATION ACT, AND A WAIVER OF CLASS ACTIONS.
              </p>
            </div>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Conditions for Use of the Site</h2>
              <p>Your access to and use of the Site is contingent upon your acceptance and adherence to these terms. By using the Site, you agree that you:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Will comply with these Terms of Service</li>
                <li>Are 18 years of age or older</li>
                <li>Will not use the Site in any way that violates U.S. laws</li>
                <li>Will not copy or distribute any content from the Site without our prior written consent</li>
                <li>Will provide accurate details when registering, submitting content, or interacting with the Site</li>
                <li>Will not permit others to use the Site under your user credentials</li>
                <li>Are fully responsible for all activity under your account</li>
                <li>Will not use the Site for commercial purposes other than those expressly stated</li>
                <li>Are solely responsible for any content you submit to the Site</li>
                <li>Grant us a non-exclusive license to use, display, reproduce, distribute, or create derivative works from your submitted materials</li>
                <li>Agree that we may remove any of your content and suspend or terminate your account</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Your Content</h2>
              <p>We reserve the right to publish any content you provide. You agree not to upload or use any content that:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Violates the intellectual property rights of others</li>
                <li>Infringes on privacy or publicity rights of any third party</li>
                <li>Is unlawful, inaccurate, defamatory, discriminatory, obscene, or harassing</li>
                <li>Encourages criminal activity or civil liability</li>
                <li>Is deemed inappropriate by us, in our sole discretion</li>
                <li>Could harm our company, affiliates, or partners</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Search Services</h2>
              <p>If you use our search services, we employ reasonable methods to identify potential matches. However, we cannot guarantee that your trademark will be approved by the USPTO or that it will not face challenges.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Trademark Search Scope</h2>
              <p>Our <strong className="text-[#09090B]">Trademark My Logo Name</strong> searches include:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-zinc-800">Federal Search:</strong> Reviews the USPTO database and includes direct matches, phonetic similarities, or visual design similarities</li>
                <li><strong className="text-zinc-800">Federal, State, and Common Law Search:</strong> Extends to all 50 states, business registries, and domain name databases</li>
                <li><strong className="text-zinc-800">Global Search:</strong> Includes USPTO, state databases, WIPO database, and European Community database</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Disclaimers of Warranty and Limitations of Liability</h2>
              <div className="bg-[#F4F4F5] border border-zinc-200 p-6 rounded-lg">
                <p className="text-xs uppercase font-bold mb-3 text-zinc-800">IMPORTANT LEGAL NOTICE</p>
                <p className="text-sm">
                  WE PROVIDE THE WEBSITE AND RELATED SERVICES "AS IS", "WHERE IS", AND "AS AVAILABLE." TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ANY AND ALL EXPRESS OR IMPLIED WARRANTIES. WE MAKE NO GUARANTEE THAT THE WEBSITE WILL MEET YOUR REQUIREMENTS, IS ERROR-FREE, ACCURATE, RELIABLE, WITHOUT INTERRUPTION OR AVAILABLE AT ALL TIMES.
                </p>
                <p className="text-sm mt-3">
                  WE SHALL NOT BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES ARISING FROM YOUR USE OF, INABILITY TO USE, OR RELIANCE UPON THE WEBSITE IN ANY WAY.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Dispute Resolution & Arbitration</h2>
              <p>Any dispute shall be FINALLY and EXCLUSIVELY resolved by binding individual arbitration conducted by the American Arbitration Association ("AAA") under its Consumer Arbitration Rules.</p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 my-4">
                <p className="text-sm font-bold text-zinc-700">
                  NO CLASS ACTION, OR OTHER REPRESENTATIVE ACTION OR PRIVATE ATTORNEY GENERAL ACTION OR JOINDER OR CONSOLIDATION OF ANY CLAIM WITH A CLAIM OF ANOTHER PERSON SHALL BE ALLOWABLE.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Refund Policy</h2>
              <p>All packages include attorney-conducted searches and are non-refundable. Once a search and clearance report is issued, payment will be automatically processed within 24-48 hours if we do not receive a response from you via email or phone.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Contact Information</h2>
              <p>If you have any questions regarding these Terms & Conditions, please contact us at:</p>
              <div className="bg-[#F4F4F5] border border-zinc-200 p-6 rounded-lg mt-4">
                <p><strong className="text-zinc-800">Company:</strong> Trademark My Logo Name</p>
                <p><strong className="text-zinc-800">Address:</strong> 515 Flower St, Los Angeles, CA 90071, United States</p>
                <p><strong className="text-zinc-800">Phone:</strong> (800) 555-1234</p>
                <p><strong className="text-zinc-800">Email:</strong> info@trademarkmylogoname.com</p>
              </div>
            </section>

            <p className="text-sm text-zinc-400 mt-8 pt-8 border-t border-zinc-200">
              <strong>Last Updated:</strong> January 1, 2025
            </p>

            <p className="mt-4">By using our website and services, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions.</p>
          </div>
        </div>
      </div>

      <Footer onOpenContactForm={() => {}} />
    </div>
  );
};

export default TermsConditions;
